// document.addEventListener("DOMContentLoaded", function() {
//   const canvas = document.getElementById("snowCanvas"),
//     ctx = canvas.getContext("2d");
//   canvas.width = window.innerWidth, canvas.height = window.innerHeight;
//   const snowflakes = [];
//   let numSnowflakes = getSnowflakeCount(),
//     snowflakeSizeRange = getSnowflakeSize();
//   class Snowflake {
//     constructor() {
//       this.x = Math.random() * canvas.width, this.y = Math.random() * canvas.height, this.size = Math.random() * (snowflakeSizeRange[1] - snowflakeSizeRange[0]) + snowflakeSizeRange[0], this.speedY = Math.random() * 1 + .5, this.speedX = Math.random() * .5 - .25
//     }
//     update() {
//       this.y += this.speedY, this.x += this.speedX, this.y > canvas.height && (this.y = -this.size, this.x = Math.random() * canvas.width), (this.x > canvas.width || this.x < 0) && (this.speedX = -this.speedX)
//     }
//     draw() {
//       ctx.font = `${this.size}px sans-serif`, ctx.shadowColor = "rgba(255, 255, 255, 0.6)", ctx.shadowBlur = 4, ctx.shadowOffsetX = 2, ctx.shadowOffsetY = 2, ctx.fillStyle = "white", ctx.fillText("\u2746", this.x, this.y), ctx.shadowColor = "transparent"
//     }
//   }
//   function getSnowflakeCount() {
//     return window.innerWidth <= 768 ? 10 : 15
//   }
//   function getSnowflakeSize() {
//     return window.innerWidth <= 768 ? [3, 10] : [8, 20]
//   }
//   function generateSnowflakes() {
//     numSnowflakes = getSnowflakeCount(), snowflakeSizeRange = getSnowflakeSize(), snowflakes.length = 0;
//     for (let i = 0; i < numSnowflakes; i++) snowflakes.push(new Snowflake)
//   }
//   generateSnowflakes();
//   function animate() {
//     ctx.clearRect(0, 0, canvas.width, canvas.height), snowflakes.forEach(snowflake => {
//       snowflake.update(), snowflake.draw()
//     }), requestAnimationFrame(animate)
//   }
//   animate(), window.addEventListener("resize", () => {
//     canvas.width = window.innerWidth, canvas.height = window.innerHeight, generateSnowflakes()
//   })
// });
document.addEventListener("DOMContentLoaded", function() {
  const canvas = document.getElementById("snowCanvas");
  const ctx = canvas.getContext("2d");

  function resizeCanvas() {
    canvas.width = window.innerWidth;
    canvas.height = window.innerHeight;
  }
  resizeCanvas();
  const snowflakes = [];
  let numSnowflakes = getSnowflakeCount();
  let snowflakeSizeRange = getSnowflakeSize();
  class Snowflake {
    constructor() {
      this.reset();
    }
    reset() {
      this.x = Math.random() * canvas.width;
      this.y = Math.random() * canvas.height;
      this.size = Math.random() * (snowflakeSizeRange[1] - snowflakeSizeRange[0]) + snowflakeSizeRange[0];
      //   this.speedY = Math.random() * 1 + 0.5;
      this.speedY = Math.random() * 2 + 1;
      this.speedX = Math.random() * 0.5 - 0.25;
    }
    update() {
      this.y += this.speedY;
      this.x += this.speedX;
      if (this.y > canvas.height) {
        this.y = -this.size;
        this.x = Math.random() * canvas.width;
      }
      if (this.x > canvas.width || this.x < 0) {
        this.speedX *= -1;
      }
    }
    draw() {
      ctx.font = `${this.size}px sans-serif`;
      ctx.fillStyle = "#fff";
      ctx.shadowColor = "rgba(255,255,255,0.6)";
      ctx.shadowBlur = 4;
      ctx.fillText("❆", this.x, this.y);
      ctx.shadowColor = "transparent";
    }
    // draw() {
    //   ctx.beginPath();
    //   ctx.arc(this.x, this.y, this.size / 3.5, 0, Math.PI * 2); // smaller size
    //   ctx.fillStyle = "rgba(255,255,255,0.5)"; // soft white
    //   ctx.shadowColor = "rgba(255,255,255,0.8)";
    //   ctx.shadowBlur = 1; // blur glow
    //   ctx.fill();
    //   ctx.closePath();
    // }
  }

  function getSnowflakeCount() {
    // return window.innerWidth <= 768 ? 10 : 15;   // for less Snowfall (Number of Flakes)
    return window.innerWidth <= 768 ? 25 : 50;      // for Balanced & Smooth Snowfall (Number of Flakes)
    // return window.innerWidth <= 768 ? 40 : 80;      // for Heavy Snowfall Snowfall (Number of Flakes)
    // return window.innerWidth <= 768 ? 60 : 120;     // for Extreme / Festive Effect Snowfall (Number of Flakes)
  }

  function getSnowflakeSize() {
    return window.innerWidth <= 768 ? [3, 10] : [8, 20];
  }

  function generateSnowflakes() {
    snowflakes.length = 0;
    numSnowflakes = getSnowflakeCount();
    snowflakeSizeRange = getSnowflakeSize();
    for (let i = 0; i < numSnowflakes; i++) {
      snowflakes.push(new Snowflake());
    }
  }

  function animate() {
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    snowflakes.forEach((flake) => {
      flake.update();
      flake.draw();
    });
    requestAnimationFrame(animate);
  }
  generateSnowflakes();
  animate();
  window.addEventListener("resize", () => {
    resizeCanvas();
    generateSnowflakes();
  });
});